/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const ourServiceTabContentStyle = {
  ourServiceTabContent: (theme: Theme) => ({
    paddingInline: 0,
    [theme.breakpoints.up("lg")]: {
      paddingInline: "8rem",
    },
  }),
  image: (theme: Theme) => ({
    width: "75%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
  }),
};
